import { Button } from "@mui/material";
import {
  getInitialBudgetCost,
  getModifiedBudgetCost,
  getAvailableBudgetCost,
} from "../helper";
import { convertToCamelCaseFromUnderScore } from "../../../../common-utilities/utils";
import { Checkbox, Tooltip } from "@mui/material";

export const getHeaderConfig = (
  editVendor,
  handleRowSelection,
  selectedBudgetList,
  dataList
) => {
  const headers = [
    {
      id: "checkbox",
      label: (
        <Checkbox
          onChange={(event) => handleRowSelection(event, null, "selectAll")}
          checked={
            selectedBudgetList.length === dataList.length &&
            dataList.length !== 0
          }
        />
      ),
      sortable: false,
      render: (data, index) => {
        return (
          <Checkbox
            checked={
              selectedBudgetList.find((ele) => ele.id === data.id)
                ? true
                : false
            }
            onChange={(event) => handleRowSelection(event, data)}
          />
        );
      },
    },
    {
      label: "Budget Id",
      id: "document.budgetId.id",
    },
    {
      label: "Site Code",
      id: "site.code",
    },
    {
      label: "Site Name",
      id: "site.name",
    },
    {
      label: "Budget Type",
      id: "budgetType",
      render: (data) => {
        const { document = {} } = data;
        const { budgetId = {} } = document || {};
        return convertToCamelCaseFromUnderScore(budgetId.budgetType);
      },
    },
    {
      label: "Initial Budget",
      id: "initial",
      render: (data) => {
        const { document = {} } = data;
        const { budgetId = {} } = document || {};
        const { lineItems = [] } = budgetId || {};
        return getInitialBudgetCost(lineItems);
      },
    },
    {
      label: "Modified",
      id: "modified",
      render: (data) => {
        const { document = {} } = data;
        const { budgetId = {} } = document || {};
        const { lineItems = [] } = budgetId || {};
        return getModifiedBudgetCost(lineItems);
      },
    },
    {
      label: "Available Budget",
      id: "available",
      render: (data) => {
        const { document = {} } = data;
        const { budgetId = {} } = document || {};
        const { lineItems = [] } = budgetId || {};
        return getAvailableBudgetCost(lineItems);
      },
    },
    {
      label: "Budget Remarks",
      id: "budgetRemarks",
      render: (data) => {
        const { document = {} } = data;
        const { comment = "" } = document || {};
        if (!comment) {
          return "-";
        }
        return (
          <Tooltip
            title={comment}
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba(33, 33, 33, 0.95)",
                  fontSize: 12,
                  lineHeight: 1.5,
                  maxWidth: 300,
                  padding: "8px 12px",
                },
              },
            }}
          >
            <div
              style={{
                width: 200,
                margin: "0 auto",
                textAlign: "center",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                wordBreak: "break-word",
              }}
            >
              {comment}
            </div>
          </Tooltip>
        );
      },
    },
    {
      label: "Actions",
      id: "actions",
      render: (data) => {
        const { status } = data;
        return (
          <Button variant="text" onClick={() => editVendor(data, "VIEW")}>
            View
          </Button>
        );
      },
    },
  ];
  return headers;
};

const getApprovalLineItem = (data) => {
  const { document = {} } = data;
  const { budgetId = {}, lineItemId } = document || {};
  const { lineItems = [] } = budgetId || {};
  return lineItems.find((item) => +item.id === +lineItemId) || {};
};

export const getLineItemHeaderConfig = (
  viewBudget,
  handleRowSelection,
  selectedBudgetList,
  dataList
) => {
  const budgetHeaders = getHeaderConfig(
    viewBudget,
    handleRowSelection,
    selectedBudgetList,
    dataList
  );
  const [checkbox, budgetId, siteCode, siteName, budgetType] = budgetHeaders;
  const actions = budgetHeaders[budgetHeaders.length - 1];
  const budgetRemarks = budgetHeaders.find(
    (header) => header.id === "budgetRemarks"
  );
  return [
    checkbox,
    budgetId,
    siteCode,
    siteName,
    budgetType,
    {
      label: "Line Item",
      id: "lineItemName",
      render: (data) => getApprovalLineItem(data).name || "-",
    },
    {
      label: "Current Amount",
      id: "oldPrice",
      render: (data) => {
        const { document = {} } = data;
        return (+(document?.oldPrice || 0)).toFixed(2);
      },
    },
    {
      label: "Requested Amount",
      id: "updatedPrice",
      render: (data) => {
        const { document = {} } = data;
        return (+(document?.updatedPrice || 0)).toFixed(2);
      },
    },
    {
      label: "Difference",
      id: "difference",
      render: (data) => {
        const { document = {} } = data;
        return (
          +(document?.updatedPrice || 0) - +(document?.oldPrice || 0)
        ).toFixed(2);
      },
    },
    budgetRemarks,
    {
      label: "Requested By",
      id: "creatorName",
      render: (data) => data?.document?.creatorName || "-",
    },
    {
      label: "Date",
      id: "createdAt",
      render: (data) => {
        if (!data.createdAt) return "-";
        return new Date(data.createdAt).toLocaleDateString("en-IN");
      },
    },
    actions,
  ];
};
